import { createRoute, Navigate } from "@tanstack/react-router";
import { RootRoute } from "../root-route";

export const SourcesRoute = createRoute({
  getParentRoute: () => RootRoute,
  path: "/sources",
  component: SourcesRedirect,
  head: () => ({
    meta: [
      { title: "Källor | Bevattningskartan" },
      { name: "description", content: "Datakällor och metod för Bevattningskartan." },
    ],
    links: [
      { rel: "canonical", href: "https://bevattningskartan.se/kallor" },
    ],
  }),
});

function SourcesRedirect() {
  return <Navigate to="/kallor" replace />;
}
